import {useCallback, useState} from 'react';
import styles from './company-registration-page.module.css';
import {ConfirmStep} from './steps/confirm-step';
import {InputStep} from './steps/input-step';
import {defaultValues, type FormSchema} from './form';
import {MasterDataProvider} from './components/master-data-provider';
import {usePostRegisterMutation} from './api/mutations/use-post-form-data-mutation';
import {convertToCompanyRegistrationFormData} from './lib/convert-to-company-registration-form-data';
import {CompleteStep} from './steps/complete-step';

export function CompanyRegistrationPage() {
  const [formValues, setFormValues] = useState<FormSchema>(defaultValues);
  const [screenType, setScreenType] = useState<'form' | 'confirm' | 'complete'>(
    'form',
  );

  const {mutateAsync, isPending, isSuccess} = usePostRegisterMutation();

  const nextToConfirm = useCallback((values: FormSchema) => {
    setFormValues(values);
    setScreenType('confirm');
    window.scrollTo({top: 0, behavior: 'smooth'});
  }, []);

  const backToForm = useCallback(() => {
    setScreenType('form');
    window.scrollTo({top: 0, behavior: 'smooth'});
  }, []);

  const submit = useCallback(async () => {
    await mutateAsync(convertToCompanyRegistrationFormData(formValues));
    setScreenType('complete');
    window.scrollTo({top: 0, behavior: 'smooth'});
  }, [formValues, mutateAsync]);

  return (
    <MasterDataProvider>
      <div className={styles.container}>
        {screenType === 'form' ? (
          <InputStep
            defaultValues={formValues}
            onClickConfirm={nextToConfirm}
          />
        ) : screenType === 'confirm' ? (
          <ConfirmStep
            formValues={formValues}
            isDisabled={isPending || isSuccess}
            onClickEdit={backToForm}
            onClickSubmit={submit}
          />
        ) : (
          <CompleteStep />
        )}
      </div>
    </MasterDataProvider>
  );
}
